<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo" style="height: 600px !important;position: relative !important;">
            <div class="contenedor_nombre_sucursal">
                {{ sucursal_seleccionada.nombre }} -- ID: {{ sucursal_seleccionada.codigo }}
            </div>
            <div class="contenedor_modal_cabecera">
                <b-button type="button" size="sm" v-shortkey="['esc']" @shortkey="cerrar" variant="danger"
                    @click="cerrar"><i class="fas fa-times"></i></b-button>
            </div>

            <b-container fluid="">
                <b-row>
                    <div class="col-sm-12 mt-3">
                        <b-tabs content-class="mt-3" fill>
                            <b-tab title="Productos" active @click="set_tab('productos')"></b-tab>
                            <b-tab title="Usuarios" @click="set_tab('datos')"></b-tab>
                        </b-tabs>
                    </div>
                    <div class="col-sm-12 mt-1">
                        <ListaProductos v-if="contenido == 'productos'" />
                        <Informacion v-if="contenido == 'datos'" />
                    </div>
                </b-row>
            </b-container>
        </div>



    </div>
</template>

<script>
    import ListaProductos from './ListaProductos.vue'
    import Informacion from './Informacion.vue'
    import { mapState } from 'vuex'

    export default {
        name: 'Ficha',
        components: {
            ListaProductos,
            Informacion
        },
        computed: {
            ...mapState(['sucursal_seleccionada'])
        },
        data() {
            return {
                contenido: 'productos'
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            set_tab(tab) {
                this.contenido = tab
            }
        },
    }
</script>

<style>
    .contenedor_nombre_sucursal {
        position: absolute;
        font-weight: bold;
        top: 9px;
        left: 5px;
    }

</style>